import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { Download, Print, Email } from "@mui/icons-material";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Resume1 from "./DuplicateResume/Resume1";
import Resume2 from "./DuplicateResume/Resume2";
import Resume3 from "./DuplicateResume/Resume3";
import Resume4 from "./DuplicateResume/Resume4";
import Resume5 from "./DuplicateResume/Resume5";
import Resume6 from "./DuplicateResume/Resume6";
import Resume7 from "./DuplicateResume/Resume7";
import Resume8 from "./DuplicateResume/Resume8";
import Resume9 from "./DuplicateResume/Resume9";
import Resume10 from "./DuplicateResume/Resume10";
import Resume11 from "./DuplicateResume/Resume11";
import Resume12 from "./DuplicateResume/Resume12";
import Resume13 from "./DuplicateResume/Resume13";
import Resume14 from "./DuplicateResume/Resume14";
import Resume15 from "./DuplicateResume/Resume15";
import Resume16 from "./DuplicateResume/Resume16";
import Resume17 from "./DuplicateResume/Resume17";
import Resume18 from "./DuplicateResume/Resume18";
import Resume19 from "./DuplicateResume/Resume19";
import Resume20 from "./DuplicateResume/Resume20";
import Resume21 from "./DuplicateResume/Resume21";
import Resume22 from "./DuplicateResume/Resume22";
import Resume23 from "./DuplicateResume/Resume23";
import Resume24 from "./DuplicateResume/Resume24";
import Resume25 from "./DuplicateResume/Resume25";
import Resume26 from "./DuplicateResume/Resume26";
import Resume27 from "./DuplicateResume/Resume27";
import Resume28 from "./DuplicateResume/Resume28";
import Resume29 from "./DuplicateResume/Resume29";
import Resume30 from "./DuplicateResume/Resume30";
import Resume31 from "./DuplicateResume/Resume31";
import Resume32 from "./DuplicateResume/Resume32";
import Resume33 from "./DuplicateResume/Resume33";
import Resume34 from "./DuplicateResume/Resume34";
import Resume35 from "./DuplicateResume/Resume35";
import Resume36 from "./DuplicateResume/Resume36";
import Resume37 from "./DuplicateResume/Resume37";
import Resume38 from "./DuplicateResume/Resume38";
import Resume39 from "./DuplicateResume/Resume39";
import Resume40 from "./DuplicateResume/Resume40";

import Resume41 from "./DuplicateResume/Resume41";
import Resume42 from "./DuplicateResume/Resume42";
import Resume43 from "./DuplicateResume/Resume43";
import Resume44 from "./DuplicateResume/Resume44";
import Resume45 from "./DuplicateResume/Resume45";
import Resume46 from "./DuplicateResume/Resume46";
import Resume47 from "./DuplicateResume/Resume47";
import Resume48 from "./DuplicateResume/Resume48";
import Resume49 from "./DuplicateResume/Resume49";
import Resume50 from "./DuplicateResume/Resume50";
// Recommended & all colors
const recommendedColors = ["#0951b0ff", "#34a853", "#fbbc05", "#ea4335", "#9c27b0", "#ff5722"];
const allColors = [
  "#000000", "#FFFFFF", "#1a73e8", "#34a853", "#fbbc05", "#ea4335",
  "#9c27b0", "#ff5722", "#00bcd4", "#4caf50", "#ff9800", "#795548",
  "#607d8b", "#e91e63", "#3f51b5", "#8bc34a", "#cddc39", "#ffc107",
  "#673ab7", "#2196f3", "#ffeb3b", "#9e9e9e", "#b71c1c", "#004d40",
  "#ff1744", "#00695c", "#1de9b6", "#f06292", "#ff7043", "#00e5ff",
];

// Helper to darken colors
function getDarkColor(hex) {
  if (!hex || typeof hex !== "string") return "#0951b0ff";
  let c = hex.replace("#", "");
  if (c.length === 8) c = c.slice(0, 6);
  if (c.length !== 6 || isNaN(parseInt(c, 16))) return "#0951b0ff";
  let r = Math.max(0, parseInt(c.substring(0, 2), 16) - 40);
  let g = Math.max(0, parseInt(c.substring(2, 4), 16) - 40);
  let b = Math.max(0, parseInt(c.substring(4, 6), 16) - 40);
  return `#${r.toString(16).padStart(2, "0")}${g.toString(16).padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
}

// Templates with premium flag - CORRECTED PREMIUM STATUS
const templates = [
  { id: 1,  component: Resume1,  name: "Template 1",  premium: true },
  { id: 2,  component: Resume2,  name: "Template 2",  premium: true },
  { id: 3,  component: Resume3,  name: "Template 3",  premium: false },
  { id: 4,  component: Resume4,  name: "Template 4",  premium: true },
  { id: 5,  component: Resume5,  name: "Template 5",  premium: true },
  { id: 6,  component: Resume6,  name: "Template 6",  premium: false },
  { id: 7,  component: Resume7,  name: "Template 7",  premium: true },
  { id: 8,  component: Resume8,  name: "Template 8",  premium: true },
  { id: 9,  component: Resume9,  name: "Template 9",  premium: true },
  { id: 10, component: Resume10, name: "Template 10", premium: true },
  { id: 11, component: Resume11, name: "Template 11", premium: true },
  { id: 12, component: Resume12, name: "Template 12", premium: false },
  { id: 13, component: Resume13, name: "Template 13", premium: false },
  { id: 14, component: Resume14, name: "Template 14", premium: false },
  { id: 15, component: Resume15, name: "Template 15", premium: false },
  { id: 16, component: Resume16, name: "Template 16", premium: true },
  { id: 17, component: Resume17, name: "Template 17", premium: true },
  { id: 18, component: Resume18, name: "Template 18", premium: false },
  { id: 19, component: Resume19, name: "Template 19", premium: false },
  { id: 20, component: Resume20, name: "Template 20", premium: true },
  { id: 21, component: Resume21, name: "Template 21", premium: false },
  { id: 22, component: Resume22, name: "Template 22", premium: true },
  { id: 23, component: Resume23, name: "Template 23", premium: true },
  { id: 24, component: Resume24, name: "Template 24", premium: true },
  { id: 25, component: Resume25, name: "Template 25", premium: true },
  { id: 26, component: Resume26, name: "Template 26", premium: true },
  { id: 27, component: Resume27, name: "Template 27", premium: true },
  { id: 28, component: Resume28, name: "Template 28", premium: false },
  { id: 29, component: Resume29, name: "Template 29", premium: true },
  { id: 30, component: Resume30, name: "Template 30", premium: false },
  { id: 31, component: Resume31, name: "Template 31", premium: true },
  { id: 32, component: Resume32, name: "Template 32", premium: false },
  { id: 33, component: Resume33, name: "Template 33", premium: false },
  { id: 34, component: Resume34, name: "Template 34", premium: false },
  { id: 35, component: Resume35, name: "Template 35", premium: false },
  { id: 36, component: Resume36, name: "Template 36", premium: false },
  { id: 37, component: Resume37, name: "Template 37", premium: false },
  { id: 38, component: Resume38, name: "Template 38", premium: true },
  { id: 39, component: Resume39, name: "Template 39", premium: true },
  { id: 40, component: Resume40, name: "Template 40", premium: true },
  { id: 41, component: Resume41, name: "Template 41", premium: false },
  { id: 42, component: Resume42, name: "Template 42", premium: true },
  { id: 43, component: Resume43, name: "Template 43", premium: false },
  { id: 44, component: Resume44, name: "Template 44", premium: true },
  { id: 45, component: Resume45, name: "Template 45", premium: false },
  { id: 46, component: Resume46, name: "Template 46", premium: false },
  { id: 47, component: Resume47, name: "Template 47", premium: false },
  { id: 48, component: Resume48, name: "Template 48", premium: true },
  { id: 49, component: Resume49, name: "Template 49", premium: false },
  { id: 50, component: Resume50, name: "Template 50", premium: true }, // Fixed: Was using Resume49 component
];

const TemplatesComponent = ({ selectedTemplate, setSelectedTemplate, selectedColor, setSelectedColor, setDesignSettings }) => {
  const [showAllColors, setShowAllColors] = useState(false);

  // internal state when parent does not control props
  const [internalSelectedTemplate, setInternalSelectedTemplate] = useState(selectedTemplate || (templates[0] && templates[0].id) || 1);
  const [internalSelectedColor, setInternalSelectedColor] = useState(selectedColor || "#0951b0ff");

  const currentSelectedTemplate = selectedTemplate !== undefined && selectedTemplate !== null ? selectedTemplate : internalSelectedTemplate;
  const currentSelectedColor = selectedColor !== undefined && selectedColor !== null ? selectedColor : internalSelectedColor;

  const updateSelectedTemplate = (id) => {
    if (typeof setSelectedTemplate === 'function') setSelectedTemplate(id);
    else setInternalSelectedTemplate(id);
  };

  const updateSelectedColor = (c) => {
    if (typeof setSelectedColor === 'function') setSelectedColor(c);
    else setInternalSelectedColor(c);
  };

  // Download dialog state
  const [openDownloadDialog, setOpenDownloadDialog] = useState(false);
  const [fileName, setFileName] = useState("resume");
  const [fileType, setFileType] = useState("pdf");

  // Keep the very first selected color as "default" (only runs once)
  const [resumeDefaultColor] = useState(currentSelectedColor || "#0951b0ff");

  const SelectedResume = templates.find((t) => t.id === currentSelectedTemplate)?.component;

  // Print / download helpers (kept simple)
  const handlePrint = () => {
    const resumeElement = document.getElementById("resume-preview");
    if (!resumeElement) return;
    const printWindow = window.open("", "_blank");
    const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
      .map((node) => node.outerHTML)
      .join("\n");
    printWindow.document.write(`
      <html><head><title>Print Resume</title>${styles}</head><body><div id="resume-preview">${resumeElement.innerHTML}</div></body></html>
    `);
    printWindow.document.close();
    printWindow.onload = () => { setTimeout(() => { printWindow.focus(); printWindow.print(); }, 500); };
  };

  const handleDownload = async () => {
    const resumeElement = document.getElementById("resume-preview");
    if (!resumeElement) return;
    if (fileType === "png" || fileType === "pdf") {
      const canvas = await html2canvas(resumeElement, { scale: 2 });
      if (fileType === "png") {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = `${fileName}.png`;
        link.click();
      } else {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, pdf.internal.pageSize.getHeight());
        pdf.save(`${fileName}.pdf`);
      }
    } else if (fileType === 'txt') {
      const blob = new Blob([resumeElement.innerText], { type: 'text/plain;charset=utf-8' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.txt`;
      link.click();
    }
    setOpenDownloadDialog(false);
  };

  return (
    <Box sx={{ width: "100%", pb: { xs: 10, md: 4 } }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>Templates</Typography>

      <Box mt={2}>
        <Typography gutterBottom>Choose Color</Typography>
        <Box display="flex" gap={1} flexWrap="wrap">
          <Box onClick={() => updateSelectedColor(resumeDefaultColor)} sx={{ width:24,height:24,borderRadius:'50%',bgcolor:'#fff',display:'flex',alignItems:'center',justifyContent:'center',border:'2px dashed #000',cursor:'pointer',fontSize:'12px',color:'#000',fontWeight:'bold' }}>R</Box>
          {recommendedColors.map((color) => (
            <Box key={color} onClick={() => updateSelectedColor(color)} sx={{ width:24,height:24,borderRadius:'50%',bgcolor:color,border: currentSelectedColor === color ? '2px solid #000' : '2px solid transparent', cursor:'pointer', transition:'transform 0.2s', '&:hover':{transform:'scale(1.15)'}}} />
          ))}
        </Box>

        <Button size="small" onClick={() => setShowAllColors(!showAllColors)} sx={{ mt:1, textTransform:'none' }}>{showAllColors ? 'See Less' : 'See All'}</Button>

        {/* Reset whole design (template + color + formatting) */}
        <Button size="small" onClick={() => {
          const defaultTemplateId = (templates[0] && templates[0].id) || 1;
          updateSelectedTemplate(defaultTemplateId);
          updateSelectedColor(resumeDefaultColor);
          if (typeof setDesignSettings === 'function') {
            setDesignSettings({
              color: resumeDefaultColor,
              font: 'EB Garamond',
              fontSize: '14px',
              fontStyle: 'normal',
              headingSize: '24px',
              sectionSpacing: 10,
              paragraphSpacing: 10,
              lineSpacing: 20,
              topBottomMargin: 20,
              sideMargins: 20,
              paragraphIndent: 0,
              lineWeight: 1,
              pageSize: 'A4'
            });
          }
        }} sx={{ mt:1, ml:2, textTransform:'none' }}>Reset to Default</Button>

        {showAllColors && (
          <Grid container spacing={1} mt={1}>
            {allColors.map((color) => (
              <Grid item xs={3} key={color}>
                <Box onClick={() => updateSelectedColor(color)} sx={{ width:24,height:24,borderRadius:'50%',bgcolor:color,border: currentSelectedColor === color ? '2px solid #000' : '2px solid transparent', cursor:'pointer','&:hover':{transform:'scale(1.15)'}}} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>

      <Grid container spacing={2} mt={3}>
        {templates.map((tpl) => {
          const TemplateComp = tpl.component;
          const safeColor = currentSelectedColor || '#0951b0ff';
          return (
            <Grid item xs={6} key={tpl.id}>
              <Box onClick={() => updateSelectedTemplate(tpl.id)} sx={{ border: currentSelectedTemplate === tpl.id ? `2px solid ${safeColor}` : '1px solid #e2e8f0', borderRadius:'12px', cursor:'pointer', boxShadow: currentSelectedTemplate === tpl.id ? '0 10px 20px rgba(0,0,0,0.08)' : '0 2px 4px rgba(0,0,0,0.02)', transition:'all 0.3s', height:'260px', width:'100%', maxWidth:'170px', mx:'auto', overflow:'hidden', position:'relative', '&:hover':{ transform:'translateY(-4px)', boxShadow:'0 12px 24px rgba(0,0,0,0.08)', borderColor: safeColor } }}>
                {tpl.premium && (<Box sx={{ position:'absolute', top:8, right:8, bgcolor:'#ffd700', color:'#000', width:32, height:32, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 3px 8px rgba(0,0,0,0.35)', zIndex:10, fontSize:'20px', fontWeight:'bold', border:'2px solid #fff' }}>★</Box>)}
                <Box sx={{ transform:'scale(0.2)', transformOrigin:'top left' }}>
                  <TemplateComp theme={{ primary: safeColor, dark: getDarkColor(safeColor) }} color={safeColor} />
                </Box>
                <Typography variant='caption' align='center' sx={{ py:0.5, bgcolor:'#f5f5f5', display:'block', fontWeight: tpl.premium ? 600 : 400 }}>{tpl.name}{tpl.premium && <span style={{ color:'#d4a017', marginLeft:4 }}>★</span>}</Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default TemplatesComponent;